import { DashboardVendor } from '../../components/Dashboard';

export function Dashboard() {
  return <DashboardVendor />;
}
